// Google tag (gtag.js) + Google Ads tracking for grimebusterswash.com.
// The Google tag is loaded sitewide from src/html.js.

// Google tag for www.grimebusterswash.com (sends to GA4 + both linked Google Ads accounts)
export const GOOGLE_TAG_ID = 'G-KM87TNPPJW'

// Google Ads "Website Estimate Form Submit" conversion, format 'AW-XXXXXXXXXX/LABEL'
export const LEAD_CONVERSION_SEND_TO = 'AW-18383059057/5DILCLei8ZAdEPHw3L1E'

// Google Ads "Calls from a website" conversion, format 'AW-XXXXXXXXXX/LABEL'
export const CALL_CONVERSION_SEND_TO = ''

// Number shown on the site. Google swaps it for a forwarding number for ad visitors.
export const BUSINESS_PHONE = '(360) 356-5910'
const BUSINESS_PHONE_DIGITS = BUSINESS_PHONE.replace(/\D/g, '')

// Inline snippet rendered into <head> by src/html.js
export function googleTagSnippet() {
  let snippet =
    'window.dataLayer=window.dataLayer||[];' +
    'function gtag(){dataLayer.push(arguments);}' +
    "gtag('js',new Date());" +
    `gtag('config','${GOOGLE_TAG_ID}');`

  if (CALL_CONVERSION_SEND_TO) {
    snippet +=
      `gtag('config','${CALL_CONVERSION_SEND_TO}',{` +
      `phone_conversion_number:'${BUSINESS_PHONE}',` +
      'phone_conversion_callback:function(formatted,mobile){' +
      'window.__gbForwardingNumber={formatted:formatted,mobile:mobile};' +
      'if(window.__gbApplyForwardingNumber){window.__gbApplyForwardingNumber();}' +
      '}});'
  }
  return snippet
}

// Swap every displayed business number (text and tel: links) for the Google forwarding number.
// Runs when Google provides a number, and again after each Gatsby route change.
export function applyForwardingNumber() {
  if (typeof document === 'undefined') return
  const fwd = window.__gbForwardingNumber
  if (!fwd || !fwd.formatted) return

  const telNumber = fwd.mobile || fwd.formatted
  document.querySelectorAll('a[href^="tel:"]').forEach((a) => {
    const hrefDigits = a.getAttribute('href').replace(/\D/g, '')
    if (hrefDigits.endsWith(BUSINESS_PHONE_DIGITS)) {
      a.setAttribute('href', 'tel:' + telNumber)
    }
  })

  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT)
  const nodes = []
  while (walker.nextNode()) {
    if (walker.currentNode.nodeValue.indexOf(BUSINESS_PHONE) !== -1) {
      nodes.push(walker.currentNode)
    }
  }
  nodes.forEach((node) => {
    node.nodeValue = node.nodeValue.split(BUSINESS_PHONE).join(fwd.formatted)
  })
}

function toE164(phone) {
  const digits = String(phone || '').replace(/\D/g, '')
  if (digits.length === 10) return '+1' + digits
  if (digits.length === 11 && digits.startsWith('1')) return '+' + digits
  return undefined
}

// Fire the lead conversion with enhanced conversion data.
// Call ONLY after the form submission has been confirmed successful.
// Resolves when Google has received the hit (or after 1s), so it is safe to navigate after.
export function trackLeadConversion({ email, phone, firstName, lastName }) {
  return new Promise((resolve) => {
    if (
      typeof window === 'undefined' ||
      typeof window.gtag !== 'function' ||
      !LEAD_CONVERSION_SEND_TO
    ) {
      resolve()
      return
    }

    const userData = {}
    if (email) userData.email = String(email).trim().toLowerCase()
    const phoneNumber = toE164(phone)
    if (phoneNumber) userData.phone_number = phoneNumber
    const address = {}
    if (firstName) address.first_name = String(firstName).trim()
    if (lastName) address.last_name = String(lastName).trim()
    if (address.first_name || address.last_name) userData.address = address

    window.gtag('set', 'user_data', userData)

    let done = false
    const finish = () => {
      if (!done) {
        done = true
        resolve()
      }
    }
    window.gtag('event', 'conversion', {
      send_to: LEAD_CONVERSION_SEND_TO,
      value: 1.0,
      currency: 'USD',
      event_callback: finish,
    })
    setTimeout(finish, 1000)
  })
}
